import BackgroundBrothers from "../components/headers/BrothersHeader";
import "../components/headers/Headers.css";
import"../components/PersonCard.css";
import PersonCard from "../components/PersonCard";
import Container from '@mui/material/Container';
import* as React from 'react';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import EBoard from "../components/Classes/EBoard";
import Nu from '../components/Classes/Nu';
import Xi from '../components/Classes/Xi';
import Omicron from '../components/Classes/Omicron';
import Pi from '../components/Classes/Pi';
import Rho from '../components/Classes/Rho';
import Sigma from '../components/Classes/Sigma';

export default function Brothers(){
  return (
    <>
    <div className="Headers">
        <BackgroundBrothers />
        <Container justifyContent="center" maxWidth='lg'>
          <h2 className="Brothers">Executive Board</h2>
          <EBoard />
          <h2>NU CLASS</h2>
            <Nu />
          <h2>XI CLASS</h2>
            <Xi />
          <h2>OMICRON CLASS</h2>
            <Omicron />
          <h2>PI CLASS</h2>
            <Pi />
          <h2>RHO CLASS</h2>
          <Rho />
          <h2>SIGMA CLASS</h2>
          <Sigma />
        </Container>
    </div>
    </>
  );
}